module.exports = __webpack_public_path__ + "img/icon_ticket.ff5eba71.svg";